import { render, staticRenderFns } from "./CardInformacoesGeraisCar.vue?vue&type=template&id=09977251&scoped=true&lang=pug"
import script from "./CardInformacoesGeraisCar.vue?vue&type=script&lang=js"
export * from "./CardInformacoesGeraisCar.vue?vue&type=script&lang=js"
import style0 from "./CardInformacoesGeraisCar.vue?vue&type=style&index=0&id=09977251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09977251",
  null
  
)

export default component.exports